import React from 'react';
import useSchemaStore from '../store/schemaStore';

const DarkModeToggle = () => {
  const { darkMode, toggleDarkMode } = useSchemaStore();

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleDarkMode();
    }
  };

  return (
    <div className="dark-mode-toggle">
      <span
        role="button"
        tabIndex={0}
        className="icon-toggle"
        onClick={toggleDarkMode}
        onKeyDown={handleKeyDown}
        title={darkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
        aria-label={darkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
      >
        {darkMode ? '☀️' : '🌙'}
      </span>
    </div>
  );
};

export default DarkModeToggle;
